import { Button, Typography, alpha, styled } from '@mui/material'
import { TooltipRenderProps } from 'react-joyride'
import { useTourContext } from '../context'

export const Tooltip = ({
  index,
  size,
  step,
  primaryProps,
  tooltipProps,
}: TooltipRenderProps) => {
  const { content } = step
  const { getStepNumber, stepNumbersOfLabel } = useTourContext()

  return (
    <Root {...tooltipProps}>
      {typeof content === 'string' ? (
        <Typography color="neutral000" variant="paragraph1">
          {content}
        </Typography>
      ) : (
        content
      )}

      <Footer>
        <DoneButton
          variant="contained"
          onClick={primaryProps.onClick}
          role={primaryProps.role}
          aria-label={primaryProps['aria-label']}
        >
          <Typography color="neutral1000" variant="subtitle3">
            {primaryProps.title}
          </Typography>
        </DoneButton>

        {size > 1 && (
          <Typography variant="subtitle1" color="neutral000">
            {getStepNumber(index + 1, size, stepNumbersOfLabel)}
          </Typography>
        )}
      </Footer>
    </Root>
  )
}

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  min-width: 200px;
  max-width: 300px;
  margin: auto;
  padding: 16px;

  background-color: ${({ theme }) => alpha(theme.palette.neutral900, 0.8)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 4}px;
  box-shadow: ${({ theme }) => theme.shadows[2]};
`

const Footer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const DoneButton = styled(Button)`
  min-width: 120px;
  height: 40px;
  background-color: ${({ theme }) => theme.palette.neutral000};

  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral100};
  }
`
